import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { WebsiteArticleContentComponent } from './website-article-content.component'
import { SharedModule } from '../shared/shared.module'
import { PipesModule } from '../../pipes/pipes.module'



@NgModule({
  declarations: [WebsiteArticleContentComponent],
  imports: [
    CommonModule,
    SharedModule,
    PipesModule
  ],
  exports: [WebsiteArticleContentComponent]
})
export class WebsiteArticleContentModule { }
